import { Controller } from "@hotwired/stimulus"

// Debounced search controller
// Automatically submits form after user stops typing for 500ms
export default class extends Controller {
  static targets = ["form"]
  static values = {
    delay: { type: Number, default: 500 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.delayValue)
  }
}
